import { PageHead } from "./PageHead";
import { generateBreadcrumbs } from "@/lib/seo";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQPageSEOProps {
  title: string;
  description: string;
  canonical: string;
  ogImage?: string;
  keywords?: string;
  path: string;
  faqItems: FAQItem[];
}

export function FAQPageSEO({
  title,
  description,
  canonical,
  ogImage,
  keywords,
  path,
  faqItems
}: FAQPageSEOProps) {
  const faqPageSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  const breadcrumbs = generateBreadcrumbs(path);

  return (
    <PageHead
      title={title}
      description={description}
      canonical={canonical}
      ogImage={ogImage}
      keywords={keywords}
      pageType="website"
      structuredData={[faqPageSchema]}
      breadcrumbs={breadcrumbs}
    />
  );
}